export default __webpack_public_path__ + "static/media/success.6cf2bbd3.svg";